import { FormikProps } from "formik";

import { checkIsCashSaleOrder } from "../utils";

export interface IUseDisableProps {
  isChangeFlow: boolean;
  isDescItemNo: boolean;
  formikHeader: FormikProps<any>;
  formikItemDetails: FormikProps<any>;
  disabledActionForCashSale: boolean;
}

function useDisable({
  isChangeFlow,
  isDescItemNo,
  formikHeader,
  formikItemDetails,
  disabledActionForCashSale
}: IUseDisableProps) {
  const isCashSaleOrder = checkIsCashSaleOrder(formikHeader?.values?.orderType);

  const isDisableDeleteButton = () => {
    if (disabledActionForCashSale) {
      return true;
    }

    const lines = formikItemDetails?.values?.lines || [];
    if (lines.length === 0) {
      return true;
    }
    return false;
  };

  const isDisableCancelItemButton = () => {
    if (disabledActionForCashSale) {
      return true;
    }
    return false;
  };

  const isDisablePriceCalcButton = () => isDisableDeleteButton();

  const isDisableAddButton = () => {
    if (disabledActionForCashSale) {
      return true;
    }

    if (isCashSaleOrder && isChangeFlow) {
      return true;
    }
    const lines = formikItemDetails?.values?.lines || [];
    if (lines.length === 0) {
      return false;
    }
    const prevAddedIndex = isDescItemNo ? 0 : lines.length - 1;
    return !lines[prevAddedIndex]?.materialCode;
  };

  const isDisableCancelOrderButton = () => {
    if (disabledActionForCashSale) {
      return true;
    }
    return false;
  };

  return {
    isDisableDeleteButton,
    isDisableCancelItemButton,
    isDisablePriceCalcButton,
    isDisableAddButton,
    isDisableCancelOrderButton
  };
}

export default useDisable;
